import { LinkColorDarkTheme } from "../../../../Constant";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LINK_COLOR_DATA } from "../../../../Data/UiKit/Alert";
import { DarkThemeLeftSection } from "./DarkThemeLeftSection";
import { DarkThemeRightSection } from "./DarkThemeRightSection";

export const DarkTheme = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={LinkColorDarkTheme} span={LINK_COLOR_DATA} />
        <CardBody>
          <Row>
            <DarkThemeLeftSection />
            <DarkThemeRightSection />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
